import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TemplateProductLine} from '../model/template-product-line';
import {AppConfig} from '../shared/app-config';
import {environment} from '../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';
import {TemplateDeliveryPath} from '../model/template-delivery-path';

const logger = factory.getLogger('BulkEditExcelService');


@Injectable({
  providedIn: 'root'
})
export class TemplateProductLinesService {

  private templateProductLines: Observable<TemplateDeliveryPath[]>;
  private templateProductLinesLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }


  public findTemplateProductLines(): Observable<TemplateDeliveryPath[]> {
    if (this.templateProductLines && !this.templateProductLinesLastCallError) {
      logger.debug('findTemplateProductLines: Cache hit.');
    }
    this.templateProductLines = (this.templateProductLines && !this.templateProductLinesLastCallError) ?
      this.templateProductLines : this.fetchTemplateProductLines();
    return this.templateProductLines;
  }

  private fetchTemplateProductLines(): Observable<TemplateProductLine[]> {
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlTemplateProductLines).pipe(map(
      response => {
        const productLines = [];

        for (const item of response['data']) {
          productLines.push(new TemplateProductLine(item.product_line));
        }

        logger.debug(`findTemplateProductLines: ${productLines.length} product lines fetched from REST`);
        this.templateProductLinesLastCallError = false;
        return productLines;
      }
      ), catchError((err: Error | HttpErrorResponse) => {
        const message = `In TemplateProductLinesService.findTemplateProductLines().`;
        this.templateProductLinesLastCallError = true;
        return throwError(ErrorDataService.overLoadError(err, message));
      }),
      publishReplay(1),
      refCount());
  }

}
